import React, { Component } from "react";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import ImageBackground from "../common/imageBackground";
import MessagesList from "./MessagesList";
import MessagePopup from "./MessagePopup";
import './styles.css';

class Service1361 extends Component {
  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    return (
      <div className="service-1361">
        <ImageBackground id="background" />
        <Switch>
          <Route path="/messages/list/:status" component={MessagesList} />
          <Route path="/messages/popup" component={MessagePopup} />
          <Route
            path="/messages"
            render={() => <Redirect to="/messages/list/unread" />}
          />
        </Switch>
      </div>
    );
  }
}

export default withRouter(Service1361);
